(function () {
  angular.module('MktzapApp.Controllers')
    .controller('RegisterWebhookController', registerWebhookController);

  registerWebhookController.$inject = ['NotificationService', 'FoundationApi', 'WebhookService', 'StatusService'];
  function registerWebhookController (NotificationService, FoundationApi, WebhookService, StatusService) {
    var vm = this
    let type = null

    vm.webhook = {
      url: null,
      status_id: null
    }

    loadWebhooks()
    loadStatus()

    vm.registerWebhook = function () {
      type = 'save';
      vm.webhook = {
        url: null,
        status_id: null
      };
      FoundationApi.publish('webhookModal', 'open')
    }

    vm.editWebhook = function (webhook) {
      type = 'update';
      vm.webhook = webhook;
      FoundationApi.publish('webhookModal', 'open')
    }

    vm.saveWebhook = function () {
      if (!vm.webhook.url) {
        NotificationService.warningHandler(null, 'O campo url do webhook esta vazio')
        return;
      }

      let requestMethod = getRequestMethod()
      if (requestMethod) {
        requestMethod
          .$promise
          .then(function (data) {
            NotificationService.successHandler(null, 'Requisição processada')
            updateWebhooksList(data)
          })
          .catch(function () {
            NotificationService.errorHandler(null, 'Erro ao processar requisição')
          });

        FoundationApi.publish('webhookModal', 'close')
      }
    }

    function updateWebhooksList (data) {
      if (type == 'save') {
        vm.webhooks.push(data)
      }
    }

    function getRequestMethod () {
      if (type == 'update') {
        return WebhookService.update({ data: vm.webhook })
      }

      if (type == 'save') {
        return WebhookService.save({ data: vm.webhook })
      }

      return null
    }

    vm.deleteWebhook = function (webhook, index) {
      WebhookService
        .delete({
          id: webhook.id
        })
        .$promise
        .then(function () {
          vm.webhooks.splice(index, 1)
          NotificationService.successHandler(null, 'Requisição processada')
        })
        .catch(function () {
          NotificationService.errorHandler(null, 'Erro ao processar requisição')
        })
    }

    function loadWebhooks () {
      WebhookService
        .all()
        .$promise
        .then(function (data) {
          vm.webhooks = data
        })
        .catch(function (data) {
          NotificationService.errorHandler(null, 'Erro ao carregar webhooks')
        });
    }

    function loadStatus () {
      StatusService
        .should_close_statuses()
        .$promise
        .then(function (data) {
          vm.shouldCloseStatuses = data
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao carregar status de finalização')
        });
    }
  }
})();
